import { all, takeEvery, select, put, call } from 'redux-saga/effects';
import actions from "./actions";
import { getClientNoteApi, getClientNotesApi } from "../../services/notes.serive";
import {ReducerType} from "../reducer.type"
import { AxiosResponse } from 'axios';
import { ClientInterface, ClientWorkspace } from '../client/client.type';
import logError from "../../utils/logError";

const getUser = (state:ReducerType) => state.client.owner;
const getItems = (state: ReducerType) => state.client.owner.workspace;

export function* GET_ALL_NOTE(action: {payload:string, type:string}){
    const items: ClientWorkspace = yield select(getItems);
    let noteUuid = action.payload;
    let user: ClientInterface = yield select(getUser);
    try{
        const response: AxiosResponse<any> = yield call(
          getClientNoteApi,
          items.uuid,
          user.uuid,
          noteUuid
        );
        if (response.data) {
            yield put({
                type: actions.SET_NOTE,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/notes/sagas/GET_ALL_NOTE", e); }
}

export function* GET_ALL_NOTES(action: {payload:string, type:string}){
    const items: ClientWorkspace = yield select(getItems);
    let clientId = action.payload;
    try{
        const response: AxiosResponse<any> = yield call(
          getClientNotesApi,
          items.uuid,
          clientId
        );
        if (response.data) {
            yield put({
                type: actions.SET_NOTES,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/notes/sagas/GET_ALL_NOTES", e); }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_NOTE, GET_ALL_NOTE),
        takeEvery(actions.GET_NOTES, GET_ALL_NOTES),
    ])
}
